import React, {forwardRef, RefObject} from 'react';
import {Icon, Input, PriorityIcon} from '@priority-software/priority-style-react';
import cx from 'classnames';
import styles from './styles.module.scss';

type Props = {
    handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    placeholder?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value: string;
    onSearch: () => void;
    submitText: React.ReactNode;
    onFocus?: () => void;
    onBlur?: () => void;
};

export const AIInput = forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
    const {handleKeyDown, placeholder, onChange, value, submitText, onSearch, onFocus, onBlur} =
        props;
    return (
        <Input
            inputRef={ref as RefObject<HTMLInputElement>}
            onKeyDown={handleKeyDown}
            componentClasses={styles.search}
            placeholder={placeholder}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            prefixIcon={
                <Icon
                    icon={PriorityIcon.ai_stars}
                    componentClasses={cx(styles.aiIcon, styles.gradientColor)}
                />
            }
            value={value}
            size="large"
            isActive
        >
            <div className={styles.searchBtn} onClick={onSearch}>
                {submitText}
            </div>
        </Input>
    );
});
